export const FIELD_ID = 'id';
export const FIELD_CONTACT = 'contact_id';
export const FIELD_SITE = 'site_id';
export const FIELD_COMPANY = 'company_id';
export const FIELD_SYSTEM = 'deal_system_id';
export const FIELD_TITLE = 'title';
export const FIELD_DESCRIPTION = 'description';
export const FIELD_STATUS = 'status';
export const FIELD_PRIORITY = 'priority';
